import React from "react"
import { useIntl } from "react-intl"
import { PhronesisCalendarProps } from "./PhronesisCalendar.domain"

import withVisibility from "../Hocs/withVisibility/withVisibility"
import MultiRangeCalendar, {
	RangeCalendar,
} from "components/Shared/MultiRangeCalendar"
import {
	PHRONESIS_PRESETS,
	MONTHS_TO_SHOW,
} from "./PhronesisCalendar.constants"
import "./PhronesisCalendar.styles.scss"
import {
	getDatesFromRanges,
	getInitialMaxDate,
	getIntialMinDate,
} from "./PhronesisCalendar.utils"
import { useFiltersContext } from "../GlobalFilter/context/filtersContext"

const PhronesisCalendar: React.FC<PhronesisCalendarProps> = (props) => {
	const { setDateInterval, setPeriodSelected = () => {} } = props
	const { interval, setInterval, preset, setPreset } = useFiltersContext()
	const [dateIntervalNotConfirmed, setDateNotConfirmed] = React.useState(
		interval
	)

	const intialMaxDate = getInitialMaxDate()
	const intialMinDate = getIntialMinDate()
	const intl = useIntl()

	const messageCalendarDays = intl.formatMessage({
		id:
			"phronesis.transactional.application.commercial.benchmark.calendar.message.days",
	})

	const handleOnChange = (rangesCalendar: RangeCalendar[]) => {
		setDateNotConfirmed(rangesCalendar)
	}

	const handleOnSubmit = (ranges: RangeCalendar[], definedRangeId: string) => {
		const dates = getDatesFromRanges(ranges)

		setInterval(ranges)
		setDateInterval(dates, definedRangeId)
		setPeriodSelected(definedRangeId)
		setPreset(definedRangeId)
	}

	return (
		<MultiRangeCalendar
			onChange={handleOnChange}
			onSubmit={handleOnSubmit}
			ranges={dateIntervalNotConfirmed}
			showPresets
			selectedPreset={preset}
			definedRanges={PHRONESIS_PRESETS}
			monthsShown={MONTHS_TO_SHOW}
			locale={intl.locale}
			maxDate={intialMaxDate}
			minDate={intialMinDate}
			footerMenu={
				<div className="benchmark-calendar__menu">
					<p className="benchmark-calendar__message">{messageCalendarDays}</p>
				</div>
			}
		/>
	)
}

export default withVisibility(PhronesisCalendar)
